<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.rebate_member") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100              
              .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListMember(true)" size="sm")
              template(v-if="searchID != ''")
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.type') }}
                  b-form-select(v-model="rebate_type" @change="getListMember(true)" size="sm")
                    option(value="") {{ $t('ui.all') }}
                    option(value="DOWNLINE") {{ $t('ui.downline') }}
                    option(value="SELF") {{ $t("ui.self") }}
              .form-group.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListMember(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="rebateMember.length > 0" mode="RebateMember" tbl="tblMember" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                //- jsonToExcelFull(v-if="rebateMemberFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="RebateMember" tbl="tblMemberFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                rebateMemberExport(v-if="rebateMember.length > 0" :tbl="rebateMember" tblId="tblMember")
                //- rebateMemberExportFull(v-if="rebateMemberFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="rebateMemberFull" tblId="tblMemberFull")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.working_date')") {{ $t('ui.short.working_date') }}
                        th.text-left(width="7%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th.text-left(width="7%" @click="sortOrder('parent_id')" v-if="!isOperator")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                          .float-right
                            i(:class="changeSortKey('parent_id')")
                        th.text-left(width="5%")
                          span(:title="$t('ui.inbox_id')") {{ $t('ui.inbox_id') }}
                        th.text-left(width="7%")
                          span(:title="$t('ui.vip_name')") {{ $t('ui.vip') }}
                        th.text-left(width="8%" @click="sortOrder('rebate_mode')")
                          span(:title="$t('ui.rebate_mode')") {{ $t('ui.rebate_mode') }}
                          .float-right
                            i(:class="changeSortKey('rebate_mode')")
                        th.text-right(width="7%" @click="sortOrder('rebate_rate')")
                          span(:title="$t('ui.rebate_rate')") {{ $t('ui.rebate_rate') }}
                          .float-right
                            i(:class="changeSortKey('rebate_rate')")
                        th.text-center(width="7%" @click="sortOrder('rebate_type')")
                          span(:title="$t('ui.rebate_type')") {{ $t('ui.rebate_type') }}
                          .float-right
                            i(:class="changeSortKey('rebate_type')")
                        th.text-right(width="8%" @click="sortOrder('total_turnover')")
                          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                          .float-right
                            i(:class="changeSortKey('total_turnover')")
                        th.text-right(width="8%" @click="sortOrder('turnover_tier')")
                          span(:title="$t('ui.turnover_tier')") {{ $t('ui.turnover_tier') }}
                          .float-right
                            i(:class="changeSortKey('turnover_tier')")
                        th.text-right(width="9%" @click="sortOrder('actual_rebate')")
                          span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
                          .float-right
                            i(:class="changeSortKey('actual_rebate')")
                        th.text-right(width="9%" @click="sortOrder('rounded_rebate')")
                          span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
                          .float-right
                            i(:class="changeSortKey('rounded_rebate')")
                        th.text-right(width="9%" @click="sortOrder('action_date')")
                          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                          .float-right
                            i(:class="changeSortKey('action_date')")
                    tbody.clusterize-content
                      tr(v-if="rebateMember.length == 0")
                        td(:colspan="!isOperator ? '13' : '12'").text-center
                          span {{ $t('message.no_data_available') }}
                      template(v-for="(item, index) in rebateMember")
                        tr
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                          td.text-left
                            span(:title="item.account_id") {{ item.account_id }}
                          td.text-left(v-if="!isOperator")
                            span(:title="item.parent_id") {{ item.parent_id }}
                          td.text-left
                            span(:title="item.inbox_id") {{ item.inbox_id }}
                          td.text-left
                            span(:title="item.vip_name")
                              i.fas.fa-crown(v-if="item.vip_name") &nbsp;{{ item.vip_name }}
                          td.text-left
                            span(:title="item.rebate_mode") {{ item.rebate_mode }}
                            template(v-if="item.rebate_mode == 'VIP TIER'")
                              i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                          td.text-right
                            span(:title="item.rebate_rate") {{ item.rebate_rate }}
                          td.text-center
                            span(:title="item.rebate_type") {{ item.rebate_type }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.total_turnover)" :title="$n(item.total_turnover, 'currency')") {{ item.total_turnover != null ? $n(item.total_turnover, 'currency') : null }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.turnover_tier)" :title="$n(item.turnover_tier, 'currency')") {{ item.turnover_tier != null ? $n(item.turnover_tier, 'currency') : null }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.actual_rebate)" :title="$n(item.actual_rebate, 'currency')") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.rounded_rebate)" :title="$n(item.rounded_rebate, 'currency')") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
                          td.text-right
                            span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}
                        tr.text-center(v-if="isShowDetail == true && currId == item.id")
                          td(colspan="14")
                            table.table.table-sm.table-bordered.table-striped.table-hover(style="width: 50%;").mb-2.m-auto
                              thead.thead-dark
                                tr
                                  th.text-left(width="25%")
                                    span {{ $t("ui.provider_code") }}
                                  th.text-right(width="25%")
                                    span {{ $t("ui.turnover") }}
                                  th.text-right(width="25%")
                                    span {{ $t("ui.rebate_rate") }}
                                  th.text-right(width="25%")
                                    span {{ $t("ui.actual_rebate") }}
                              tbody.clusterize-content
                                template(v-if="rebateProvider.length == 0")
                                  td(:colspan="12").text-center
                                    span {{ $t('message.no_data_available') }}
                                template(v-for="(item1, index1) in rebateProvider")
                                  tr
                                    td.text-left
                                      span(:title="item1.provider_code") {{ item1.provider_code }}
                                    td.text-right
                                      b-link.font-weight-bold(href="javascript:void(0);" v-if="checkActionButton(item1) && item.rebate_type == 'SELF'" @click="redirectToMemberReport(item, item1)" :class="$helpers.fontClassName(item1.turnover)" :title="$n(item1.turnover, 'currency')") {{ $n(item1.turnover, 'currency') }}
                                      span.font-weight-bold(v-else :class="$helpers.fontClassName(item1.turnover)" :title="$n(item1.turnover, 'currency')") {{ item1.turnover != null ? $n(item1.turnover, 'currency') : null }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.rebate_rate)" :title="item1.rebate_rate") {{ item1.rebate_rate }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.actual_rebate)" :title="$n(item1.actual_rebate, 'currency')") {{ item1.actual_rebate != null ? $n(item1.actual_rebate, 'currency') : null }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import rebateMemberExport from "@/components/report/rebateMemberExportFull.vue";
import rebateMemberExportFull from "@/components/report/rebateMemberExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    rebateMemberExport,
    rebateMemberExportFull
  },
  data: () => ({
    loading: false,
    loading2: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    rebateMember: [],
    rebateMemberFull: [],
    rebateProvider: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "asc",
    searchID: "",
    memberID: "",
    rebate_type: "",
    currId: null,
    isShowDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.searchID = this.accountID;
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if(this.$store.getters.reportStatement.member_id!= null)
          this.memberID = this.$store.getters.reportStatement.member_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        }
      }
      this.getListMember(true);
    }
  },
  methods: {
    getGameResultAuthVal(cat) {
      var val = ''
      switch(cat) {
        case 'SLOTS':
          val = 'gameresultslots';
          break;
        case 'LIVECASINO':
          val = 'gameresultlivecasino';
          break;
        case 'SPORTSBOOK':
          val = 'gameresultsportsbook';
          break;
        case 'COCKFIGHT':
          val = 'gameresultcockfight';
          break;
        case 'RESCUE':
          val = 'gameresultrescue';
          break;
        case 'REWARD':
          val = 'gameresultreward';
          break;
        case 'FREESLOTS':
          val = 'gameresultfreeslots';
          break;
        case 'OTHERS':
          val = 'gameresultothers';
          break;
      }
      return val;
    },
    checkActionButton(item1) {
      return this.$helpers.showActionButton(this.getGameResultAuthVal(item1.category))
    },
    redirectToMemberReport: function(item, item1) {
      this.setReportParam(item, item1);
      this.$store.dispatch("user/setSelectedOperatorID", item.parent_id);
      this.$store.dispatch("user/setSelectedMemberID", item.account_id);
      this.$router.push("/account/settings?reportTab=" + item1.category.toLowerCase());
    },
    setReportParam(item, item1) {
      var endDay = moment(item.working_date).endOf('day')
      var json = {
        start_date: moment(item.working_date).format("YYYY-MM-DD HH:mm:ss"),
        end_date: endDay.format("YYYY-MM-DD HH:mm:ss"),
      };

      switch(item1.category) {
        case 'SLOTS':
          json.provider = item1.provider_code;
          this.$store.dispatch("user/setGameResultSlotsParam", json);
          break;
        case 'LIVECASINO':
          json.provider = item1.provider_code;
          this.$store.dispatch("user/setGameResultLivecasinoParam", json);
          break;
        case 'SPORTSBOOK':
          json.provider = item1.provider_code;
          json.search_created_date = true;
          this.$store.dispatch("user/setGameResultSportsbookParam", json);
          break;
        case 'COCKFIGHT':
          json.provider = item1.provider_code;
          this.$store.dispatch("user/setGameResultCockfightParam", json);
          break;
        case 'RESCUE':
          this.$store.dispatch("user/setGameResultRescueParam", json);
          break;
        case 'REWARD':
          this.$store.dispatch("user/setGameResultRewardParam", json);
          break;
        case 'FREESLOTS':
          json.provider = item1.provider_code;
          this.$store.dispatch("user/setGameResultFreeSlotsParam", json);
          break;
        case 'OTHERS':
          json.provider = item1.provider_code;
          this.$store.dispatch("user/setGameResultOthersParam", json);
          break;
      }
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = true;
          this.currId = item.id;
          this.getRebateProvider(item.id)
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.id;
        this.getRebateProvider(item.id)
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getRebateMember(true)
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getListMember(isSearch) {
      if (this.checkDateRange()) {
        this.getRebateMember(isSearch);
        // if (this.$helpers.showExportAll(this.dateRange) == true) {
        //   this.getRebateMemberFull(isSearch);
        // }
      } else {
        this.clearRebateList();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListMember(true);
    },
    submit() {
      this.getListMember(true)
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        member_id: this.memberID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getRebateMember: function(isSearch) {
      if (this.checkDateRange()) {
        if(this.searchID == '' || this.searchID == null) this.memberID = ''
        this.setReportStatementParam();
        let url = config.rebateMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.searchID,
          member_id: this.memberID,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearRebateList()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list && response.data.ds.list.length > 0) {
                    this.rebateMember = response.data.ds.list;
                    this.totalRow = this.rebateMember.length > 0 ? this.rebateMember[0].totalrows : 0;
                  } else {
                    this.clearRebateList()
                  }
                } else {
                  if (this.feedback.status == "accountIdRequired") {
                    this.$refs.account_id.$el.focus();
                  }
                  this.clearRebateList()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearRebateList();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRebateMemberFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rebateMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.searchID,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.rebateMemberFull = response.data.ds.list;
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    getRebateProvider(rebate_id) {
      this.clearRebateProvider()
      let url = config.rebateProviderUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        rebate_id: rebate_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list.length > 0) {
                  this.rebateProvider = response.data.ds.list;
                } else {
                  this.clearRebateProvider()
                }
              } else {
                this.clearRebateProvider()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRebateList() {
      this.showTotal = false
      this.totalRow = 0
      this.rebateMember = []
    },
    clearRebateProvider() {
      this.rebateProvider = []
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.getRebateMember(true)
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo
      this.getRebateMember()
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error")
    }
  }
};
</script>